import type { Iso3166TwoDigitCountryCode } from '@onefootprint/request-types';

export type FlagProps = {
  className?: string;
  code: Iso3166TwoDigitCountryCode;
  testID?: string;
};

const Flag = ({ code, testID, className = '' }: FlagProps) => (
  <div className={`fp-f f-${code} w-5 h-[15px] bg-senary ${className}`} data-testid={testID} />
);

export default Flag;
